// Shared status logic for concession queue times and people counts.
// Keeps every concession view on the same thresholds and colors.

// Queue time target: under 10 min is green, 10 min or more is red.
// (The name is historical: 10 is where red starts, not the last green value.)
export const QUEUE_TIME_GOOD_MAX = 10;

// At or over the target, on the rounded minute people see ("10 min" is red even from 9.6)
export const isOverQueueTarget = (time) => Math.round(time) >= QUEUE_TIME_GOOD_MAX;

// Overflow means the queue was at least this long (beyond what sensors can measure), always red
export const getQueueTimeStatus = (time, overflow = false) => {
  if (overflow) return 'bad';
  return isOverQueueTarget(time) ? 'bad' : 'good';
};

// "7" or "7+" when the reading overflowed
export const formatQueueValue = (value, overflow = false) => `${value}${overflow ? '+' : ''}`;

// People count: three tiers, thresholds passed in by the caller
export const getPeopleCountStatus = (count, lowMax, mediumMax) => {
  if (count <= lowMax) return 'good';
  if (count <= mediumMax) return 'warn';
  return 'bad';
};

export const STATUS_COLORS = {
  good: 'var(--q-good)',
  warn: 'var(--q-warn)',
  bad: 'var(--q-bad)',
};
